import type { HTMLAttributes } from "react";

export type AppBootProps = HTMLAttributes<HTMLDivElement>;

/**
 * Full-application boot indicator.
 *
 * This covers only the first authenticated paint (including an auth return),
 * before a route has enough data to render. It is not an in-page loading
 * state: known page structure continues to use Skeleton.
 */
export function AppBoot({ className, ...props }: AppBootProps) {
  const classes = ["marker-app-boot"];
  if (className) {
    classes.push(className);
  }

  return (
    <div
      aria-busy="true"
      aria-label="Opening Marker"
      className={classes.join(" ")}
      role="status"
      {...props}
    >
      <img
        alt=""
        aria-hidden="true"
        className="marker-app-boot__mark marker-app-boot__mark--light"
        src="/brand/marker-app-favicon-light.svg"
      />
      <img
        alt=""
        aria-hidden="true"
        className="marker-app-boot__mark marker-app-boot__mark--dark"
        src="/brand/marker-app-favicon-dark.svg"
      />
    </div>
  );
}
